<template>
  <li :to="to" class="mobile-nav__link">
    <span class="mobile-nav__link-tag">
      <PageLink :to="to">{{ label }}</PageLink>
      <span v-if="hasDropdown" class="mobile-nav__link-plus" @click.stop="isDropdownOpen = !isDropdownOpen">
        &plus;
      </span>
    </span>

    <DropDown v-if="hasDropdown" :is-open="isDropdownOpen">
      <RouterLink
        v-for="(anchorLabel, targetId) in anchors"
        :key="targetId"
        :to="getAnchorLink(`#${targetId}`)"
        class="mobile-nav__anchor"
        @click="onClickAnchor()"
      >
        {{ anchorLabel[$lang.current] }}
      </RouterLink>
    </DropDown>
  </li>
</template>

<script>
export default {
  name: 'MobileNavLink',
  props: {
    label: { type: String, default: '' },
    to: { type: [Object, String], default: '/' },
    anchors: { type: Object, default: null }
  },
  data() {
    return {
      isDropdownOpen: false
    }
  },
  computed: {
    hasDropdown() {
      return this.anchors && Object.keys(this.anchors).length > 0
    }
  },
  methods: {
    getAnchorLink(hash) {
      return { ...this.to, hash }
    },
    onClickAnchor() {
      this.isDropdownOpen = false
    }
  }
}
</script>
